export enum VerificationCodeConfig {
  ConsecutiveRequestDelay = 60,
}
